import React from 'react';

const AddToCalendarLink = ({ eventName, startDate, endDate, details, location }:{eventName: string, startDate: Date, endDate: Date, details: string, location: string}) => {
  const formatDateTime = (date: Date) => {
    // Format the JavaScript Date object to 'YYYYMMDDTHHMMSSZ'
    return date.toISOString().replace(/-|:|\.\d\d\d/g, "");
  };

  const createGoogleCalendarLink = () => {
    const baseUrl = 'https://www.google.com/calendar/render';
    const formattedStartDate = formatDateTime(startDate);
    const formattedEndDate = formatDateTime(endDate);
    const params = new URLSearchParams({
      action: 'TEMPLATE',
      text: eventName,
      dates: `${formattedStartDate}/${formattedEndDate}`,
      details: details,
      location: location
    });
    return `${baseUrl}?${params.toString()}`;
  };

  return (
    <a href={createGoogleCalendarLink()} target="_blank" rel="noopener noreferrer">
      Add to Google Calendar
    </a>
  );
};

export default AddToCalendarLink;
